module.exports = __webpack_public_path__ + "img/fintechtimes.e752f741.png";